import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TealiumService } from './tealium-analytics.service';
import { DomModule } from '@nibtravel/shared/util/dom';
import { TealiumActionhandler } from './state/tealium.actionhandler';

@NgModule({
  imports: [CommonModule, DomModule],
  providers: [TealiumService, TealiumActionhandler],
})
export class TealiumAnalyticsModule {}
